import { toast } from 'react-toastify';

import { callApi } from '../../../../apiCaller';
import { toastError } from '../../../../utils';
import { DEFAULT_FN } from '../../../../constants';

import { setIsWaiting, setIsLoading, setRemoveLoading, setShowPopup, setShowPopupDetail, setShowRemovePopup } from '../../../../actions/general';

export const ADD_ADMIN_COUPONS = 'addAdminCoupons';
export const ADD_ADMIN_COUPON = 'addAdminCoupon';
export const UPDATE_ADMIN_COUPON = 'updateAdminCoupon';
export const DELETE_ADMIN_COUPON = 'deleteAdminCoupon';

export const API_SYSTEM_ADMIN_COUPON = 'coupon';
export const API_SYSTEM_ADMIN_COUPON_DETAIL = 'coupon/:couponId';
export const API_SYSTEM_ADMIN_COUPON_CODE = 'coupon/code/:code';

// Get All
export const addAdminCoupons = (coupons) => {
     return {
          type: ADD_ADMIN_COUPONS,
          payload: coupons,
     };
};

export const fetchAdminCoupons = () => (dispatch) => {
     dispatch(setIsLoading(true));
     callApi(API_SYSTEM_ADMIN_COUPON, 'GET')
          .then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }

               dispatch(addAdminCoupons(response.data));
          })
          .finally(() => {
               dispatch(setIsLoading(false));
          });
};

export const fetchAdminCouponByCodeRequest = (code, nextDispatch) => () => {
     const { setIsLoadingDetail = DEFAULT_FN, setCoupon = DEFAULT_FN } = nextDispatch;

     setIsLoadingDetail(true);
     callApi(API_SYSTEM_ADMIN_COUPON_CODE.replace(':code', code), 'GET')
          .then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }

               setCoupon(response.data);
          })
          .finally(() => {
               setIsLoadingDetail(false);
          });
};

// Create
export const addAdminCoupon = (coupon) => {
     return {
          type: ADD_ADMIN_COUPON,
          payload: coupon,
     };
};

export const addAdminCouponRequest = (coupon, setSubmitting) => (dispatch) => {
     dispatch(setIsWaiting(true));
     callApi(API_SYSTEM_ADMIN_COUPON, 'POST', coupon)
          .then((response) => {
               setSubmitting(false);

               if (response.status !== 200) {
                    toastError(response);
                    return;
               }

               dispatch(addAdminCoupon(response.data));
               dispatch(setShowPopup());
               toast.success('Created successfully');
          })
          .finally(() => {
               dispatch(setIsWaiting(false));
          });
};

// Update
export const updateAdminCoupon = (couponId, coupon) => {
     return {
          type: UPDATE_ADMIN_COUPON,
          payload: {
               couponId,
               coupon,
          },
     };
};

export const updateAdminCouponRequest = (couponId, newCoupon, setSubmitting) => (dispatch) => {
     dispatch(setIsWaiting(true));
     callApi(API_SYSTEM_ADMIN_COUPON_DETAIL.replace(':couponId', couponId), 'PUT', newCoupon)
          .then((response) => {
               setSubmitting(false);
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }

               dispatch(updateAdminCoupon(couponId, response.data));
               dispatch(setShowPopupDetail(null));
               toast.success('Update successfully');
          })
          .finally(() => {
               dispatch(setIsWaiting(false));
          });
};

// Delete
export const deleteAdminCoupon = (couponId) => {
     return {
          type: DELETE_ADMIN_COUPON,
          payload: couponId,
     };
};

export const deleteAdminCouponRequest = (couponId) => (dispatch) => {
     dispatch(setRemoveLoading(true));
     callApi(API_SYSTEM_ADMIN_COUPON_DETAIL.replace(':couponId', couponId), 'DELETE').then((response) => {
          if (response.status !== 200) {
               toastError(response);
               return;
          }

          dispatch(deleteAdminCoupon(couponId));
          dispatch(setRemoveLoading(false));
          dispatch(setShowRemovePopup(null));
     });
};
